import React from "react";
import "./styles.css";
import AllyCard from "../UI/ally-card";
import { alliancesTypesArray } from "../../constants/contents";

function AlliancesTypes() {
  return (
    <div className="alliances-types">
      <h1>Formas de aliarse</h1>
      <div className="alliances-types__cards">
        {alliancesTypesArray.map((alliance) => (
          <AllyCard
            icon={alliance.icon}
            title={alliance.title}
            audience={alliance.audience}
            description={alliance.description}
          />
        ))}
      </div>
    </div>
  );
}

export default AlliancesTypes;
